import {SVG} from '@svgdotjs/svg.js'

jQuery(function ($) {
    $(document).ready(function () {

        if ($(".case-study-results").length > 0 || $('.results-block').length > 0) {

            $(window).scroll(function () {

                let v2 = 0;

                if ($(".case-study-results").length > 0) {
                    v2 = Math.abs($('.case-study-results').position().top - $(window).height() / 2.25);
                } else {
                    v2 = Math.abs($('.results-block').position().top - $(window).height() / 2.25);
                }

                let v1 = $(this).scrollTop();
                // console.log(v1, '-----', v2)
                if (v1 > v2) {
                    $('.percentage-circles-image svg').removeClass('hidden');
                    $('.percentage-circles-image span').removeClass('opacity-0');
                    $('.percentage-circles-subtitle').removeClass('opacity-0');

                    $('.percentage-circles-grid__image svg').addClass('active');
                    $('.percentage-circles-grid__image span').addClass('active');
                    $('.percentage-circles-grid__subtitle').addClass('active');
                }
            });

        }
    });


});
